import moment from "moment/moment";
import React, { useEffect, useMemo } from "react";
import { VStack } from "native-base";
import FormInput from "../../../../shared/components/common/FormInput";
import { t } from "../../../../shared/services/i18n";
import AdvanceSelect from "../../../../shared/components/common/AdvanceSelect";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "react-native-toast-notifications";
import { setError } from "../../../../shared/redux/stepperSlice";
import { getLocationsByRivhitId, getLocationsByRivhitIdOptions } from "../../../../shared/redux/boxSlice";
import { checkRequired } from "../../../../shared/services/stepperService";


const BuildUniformReport = (props) => {
    const { setFieldValue, values, touched, errors, validationObject, handleChange } = props
    const error = useSelector((state) => state.stepper.error);
    const box = useSelector((state) => state.box.box);
    const toast = useToast()
    const dispatch = useDispatch()

    const locationOptions = useMemo(
        () => getLocationsByRivhitIdOptions(box?.locationsByRivhitId),
        [box?.locationsByRivhitId],
    );
    const hasInvoiceSeparation = locationOptions.length > 1;

    const years = useMemo(() => {
        return Array.from({ length: 5 }, (_, i) => moment().subtract(i, 'year').format('YYYY'))
    }, [])

    useEffect(() => {
        if (box && !box.locationsByRivhitId) {
            dispatch(getLocationsByRivhitId());
        }
    }, [box, dispatch]);

    useEffect(() => {
        if(error && error !== '') {
            toast.show(t(error?.message), { type: 'danger', duration: 5000 });
            dispatch(setError(null))
        }
    }, [error]);

    return (
        <VStack space={'1.5rem'}>
            {hasInvoiceSeparation && (
                <FormInput
                    label={t('location') + checkRequired('location_box', validationObject)}
                    name={'location_box'}
                    error={touched.location_box && errors.location_box}
                    containerProps={{ mb: 0 }}
                    width={'100%'}
                >
                    <AdvanceSelect
                        dontSort
                        options={locationOptions}
                        initValue={values.location_box}
                        onChange={(option) => setFieldValue('location_box', option?.value ?? null)}
                        isError={touched.location_box && errors.location_box}
                    />
                </FormInput>
            )}
            <FormInput
                label={t('tax-year')}
                name={'tax_year'}
                onChangeCallback={handleChange('tax_year')}
                error={touched.tax_year && errors.tax_year}
                containerProps={{ mb: 0 }}
                width={'100%'}
            >
                <AdvanceSelect options={years.map(year => ({value: year, label: year}))}
                    initValue={values.tax_year} onChange={(option) => setFieldValue('tax_year', option?.value ?? null)}
                    isError={touched.tax_year && errors.tax_year} />
            </FormInput>
        </VStack>

    )
}

export default BuildUniformReport